import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-personal-data',
  templateUrl: 'personal-data.component.html',
})
export class PersonalDataComponent {
  constructor(private router: Router) {

  }
  volver() {
    this.router.navigate(["/validate-email"]);
  }
}
